<template>
    <!-- Filters referenced from CSS: url(#noise) and url(#turbulence). -->
    <svg
        class="svg-filters"
        width="1"
        height="1"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true">
        <!-- Animated blue-ish grain laid over the source. -->
        <filter id="noise">
            <feTurbulence
                type="fractalNoise"
                baseFrequency="0.5"
                seed="1"
                numOctaves="5"
                stitchTiles="stitch"
                result="t">
                <animate
                    attributeType="XML"
                    attributeName="seed"
                    from="1"
                    to="100"
                    dur="10s"
                    repeatCount="indefinite" />
            </feTurbulence>
            <feComponentTransfer
                in="t"
                result="out">
                <feFuncA
                    type="linear"
                    slope="0.3" />
                <feFuncR
                    type="discrete"
                    tableValues="0.15" />
                <feFuncG
                    type="discrete"
                    tableValues="0.25" />
                <feFuncB
                    type="discrete"
                    tableValues="1" />
            </feComponentTransfer>
            <feMerge>
                <feMergeNode in="out" />
                <feMergeNode in="SourceGraphic" />
            </feMerge>
        </filter>

        <!-- Glitch: displaces the source and adds cyan/magenta offset copies. -->
        <filter id="turbulence">
            <feTurbulence
                type="turbulence"
                :baseFrequency="glitch.baseFrequency"
                :numOctaves="glitch.numOctaves"
                result="turbulence" />
            <feDisplacementMap
                in2="turbulence"
                in="SourceGraphic"
                result="displacementmap"
                :scale="glitch.scale"
                xChannelSelector="R"
                yChannelSelector="G" />
            <feOffset
                in="displacementmap"
                :dx="-glitch.dx"
                :dy="glitch.dy"
                result="offsetblur" />
            <feOffset
                in="displacementmap"
                :dx="glitch.dx"
                :dy="-glitch.dy"
                result="offsetblur2" />
            <feComponentTransfer
                in="offsetblur"
                result="shadow1">
                <feFuncA
                    type="linear"
                    :slope="glitch.alpha" />
                <feFuncR
                    type="discrete"
                    tableValues="0" />
                <feFuncG
                    type="discrete"
                    tableValues="1" />
                <feFuncB
                    type="discrete"
                    tableValues="1" />
            </feComponentTransfer>
            <feComponentTransfer
                in="offsetblur2"
                result="shadow2">
                <feFuncA
                    type="linear"
                    :slope="glitch.alpha" />
                <feFuncR
                    type="discrete"
                    tableValues="1" />
                <feFuncG
                    type="discrete"
                    tableValues="0" />
                <feFuncB
                    type="discrete"
                    tableValues="1" />
            </feComponentTransfer>
            <feMerge>
                <feMergeNode in="shadow1" />
                <feMergeNode in="shadow2" />
                <feMergeNode in="displacementmap" />
            </feMerge>
        </filter>
    </svg>
</template>

<script>
const IDLE = { baseFrequency: 0, numOctaves: 0, scale: 0, dx: 0, dy: 0, alpha: 0 };

/**
 * Hosts the SVG filters and plays the glitch: a short burst (0-150 ms) of
 * distortion, a weaker aftershock, then a random pause of up to 7 s.
 */
export default {
    name: 'SvgFilters',
    data: () => ({
        glitch: { ...IDLE },
        timer: null,
    }),
    mounted() {
        this.playGlitch();
    },
    beforeDestroy() {
        clearTimeout(this.timer);
    },
    methods: {
        playGlitch() {
            const duration = Math.random() * 150;
            const dx = Math.random() * 50;
            const dy = Math.random() * 15;

            Object.assign(this.glitch, { baseFrequency: 0.005, numOctaves: 2, scale: 30, dx, dy, alpha: 0.6 });
            this.after(duration, () => {
                Object.assign(this.glitch, { baseFrequency: 0.3, scale: 15, dx: dx * 0.3, dy: dy * 0.3 });
                this.after(duration * 0.3, () => {
                    Object.assign(this.glitch, IDLE);
                    this.after(Math.random() * 11000, this.playGlitch);
                });
            });
        },
        after(delay, callback) {
            this.timer = setTimeout(callback, delay);
        },
    },
};
</script>

<style scoped>
.svg-filters {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}
</style>
